<script>
  /** @type {{ children: import('svelte').Snippet }} */
  const { children } = $props();
</script>

<div class="checklist-set">
  {@render children?.()}
</div>
<style>
  .checklist-set {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-4);
  }
</style>
